/* eslint-disable @typescript-eslint/no-unused-vars */
import { NotifyIcon, RenderIconDismiss } from "@/components/ui/Icons/IconsCustom";
import { RootState } from "@/redux";
import { INotificationStore } from "@/redux/slices/notification/NotificationModel";
import { NotificationInfo } from "@/services/notification-service/entity/NotificationEntity";
import { EMessageType } from "@/services/notification-service/entity/NotificationEnum";
import { Button, MessageBar, MessageBarActions, MessageBarBody, MessageBarGroup, MessageBarTitle } from "@fluentui/react-components";
import { useSelector } from "react-redux";
import { INotificationProps } from "./Models";
import { NotificationBaseWrapper } from "./Styles";
import { useTranslation } from "react-i18next";
import { priorityDeclineType, renderTextDescPermission } from "../components/icon-permission";
import { ResourceInfo } from "@/services";
import { EDeclineType } from "@/services/resource-service/entity/Enums";
import { DialogChosenEnum } from "@/out-look/models/IDialogModel";
import { ISettingStore } from "@/redux/slices/settings/SettingModel";
import { IOrganizationStore } from "@/redux/slices/organizations/OrganizationModel";
import { IResourceStore } from "@/redux/slices/resources/ResourceReducerModel";
import { DismissRegular } from "@fluentui/react-icons";
import React from "react";

const Notification = (props: INotificationProps) => {
  // const styles = useStyles();
  const { t } = useTranslation();
  const notificationStore: INotificationStore = useSelector((state: RootState) => state.notificationInfo) as INotificationStore;
  const theme: string = useSelector((state: RootState) => state.settingInfo?.theme) as string;
  const settings: ISettingStore = useSelector((state: RootState) => state.settingInfo) as ISettingStore;
  const orgStore: IOrganizationStore = useSelector((state: RootState) => state.orgInfo) as IOrganizationStore;
  const resourceStore: IResourceStore = useSelector((state: RootState) => state.resources) as IResourceStore;

  const onRemoveNotification = (guid: string): void => {
    if (props.removeNotification) {
      props.removeNotification(guid);
    }
  };

  const handleButtonClick = (value: DialogChosenEnum, guid: string) => {
    switch (value) {
      case DialogChosenEnum.Yes:
      case DialogChosenEnum.No:
      case DialogChosenEnum.ViewOrder:
        if (props.onDialogChoice) {
          props.onDialogChoice(value, resourceStore.selectedResource || [], settings, orgStore, guid);
        }
        break;
    }
  };

  const renderMessage = (notificationInfo: NotificationInfo): string => {
    if (notificationInfo.messageType) {
      const item: ResourceInfo | null = notificationInfo?.resourceInfo || null;
      const isRecurring = notificationInfo?.isRecurring;
      switch (notificationInfo.messageType) {
        case EMessageType.AlternativeResource:
          return EMessageType.AlternativeResource;
        case EMessageType.ResourceConflict:
          if (item) {
            const meetingDeclines = (item.permission?.meetingDeclines || []).filter((item) => item.declineType !== EDeclineType.None);
            const declineType = meetingDeclines.length
              ? priorityDeclineType(meetingDeclines, isRecurring)
              : item.permission?.meetingDeclines
              ? priorityDeclineType(item.permission?.meetingDeclines, isRecurring)
              : null;
            return `${t("{{resource}} is deleted", {
              resource: notificationInfo.resourceInfo?.displayName,
            })} ${renderTextDescPermission(declineType || EDeclineType.None, t, item.exchangeProperty, isRecurring)}`;
          }
          return "";
        case EMessageType.MoveOrder:
          return `${t("Order has been moved", {
            order: notificationInfo.resourceInfo?.displayName,
          })}`;
        default:
          return "";
      }
    }
    return "";
  };

  const parseOriginalText = (text: string) => {
    const messageLines: string[] = text ? text.split(/\\r\\n|\r\n/) : [];
    return messageLines.length > 0
      ? messageLines.map((t, i) => (
          <React.Fragment key={i}>
            <span>{t}</span>
            {i < messageLines.length - 1 && <br />}
          </React.Fragment>
        ))
      : null;
  };

  const renderItem = (notificationInfo: NotificationInfo): JSX.Element => {
    if (notificationInfo.messageType) {
      switch (notificationInfo.messageType) {
        case EMessageType.AlternativeResource:
          return (
            <MessageBar key={`${notificationInfo.guid}`} intent={notificationInfo.type} icon={<NotifyIcon type={notificationInfo.type} />}>
              <MessageBarBody>{notificationInfo.message}</MessageBarBody>
              <MessageBarActions
                containerAction={<Button onClick={() => onRemoveNotification(notificationInfo.guid)} aria-label="dismiss" appearance="transparent" icon={<RenderIconDismiss theme={theme} />} />}
              />
            </MessageBar>
          );
        case EMessageType.MoveOrder: {
          const buttons = notificationInfo.buttons || [];
          return (
            <MessageBar key={`${notificationInfo.guid}`} intent={notificationInfo.type} icon={<NotifyIcon type={notificationInfo.type} />}>
              <MessageBarBody>{parseOriginalText(notificationInfo.message || "")}</MessageBarBody>
              <MessageBarActions containerAction={<Button onClick={() => onRemoveNotification(notificationInfo.guid)} aria-label="dismiss" appearance="transparent" icon={<DismissRegular />} />}>
                {buttons.map((button) => (
                  <Button key={button.id} onClick={() => handleButtonClick(button.value, notificationInfo.guid)}>
                    {button.text}
                  </Button>
                ))}
              </MessageBarActions>
            </MessageBar>
          );
        }
        default:
          return (
            <MessageBar key={`${notificationInfo.guid}`} intent={notificationInfo.type} icon={<NotifyIcon type={notificationInfo.type} />}>
              <MessageBarBody>{renderMessage(notificationInfo)}</MessageBarBody>
              <MessageBarActions
                containerAction={<Button onClick={() => onRemoveNotification(notificationInfo.guid)} aria-label="dismiss" appearance="transparent" icon={<RenderIconDismiss theme={theme} />} />}
              />
            </MessageBar>
          );
      }
    }
    return <></>;
  };

  return notificationStore.notifications?.length ? (
    <NotificationBaseWrapper className="NotificationBaseWrapper">
      <MessageBarGroup animate={"both"}>{notificationStore.notifications.map((notificationInfo: NotificationInfo) => renderItem(notificationInfo))}</MessageBarGroup>
    </NotificationBaseWrapper>
  ) : (
    <></>
  );
};

export default Notification;
